import React, {Component} from 'react'

import PropTypes from 'prop-types'

import {ErrorsComponent} from './Errors.component'

class ErrorsContainer extends Component {
    static propTypes = {
      error: PropTypes.number,
      errorHandling: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array]),
      containerRef: PropTypes.object
    }

    constructor(props) {
      super(props)

      this.state = {}
    }

    buildError() {
      let output = 'Error.'

      try {
        let match = {};
        
        if (Array.isArray(this.props.errorHandling)) {
          this.props.errorHandling.forEach(item => {
            if (item[this.props.error]) {
              match = item[this.props.error]
            }
          })
        } else {
          match = this.props.errorHandling[this.props.error]
        }

        if (match.action === 'redirect') {
          window.location.href = match.link
        }

        if (match.action === 'hide') {
          this.props.containerRef.parentNode.removeChild(this.props.containerRef)
        }

        output = match.text
      } catch (e) {
        output = 'An error occurred'
      }

      return output
    }

    render() {
      const error = this.buildError()

      return (
        <ErrorsComponent error={error} />
      )
    }
}

export default ErrorsContainer
